import { createFileRoute } from "@tanstack/react-router";
import { ManageAgentJobsRoute } from "src/containers/manageAgentJobsRoute";

export const Route = createFileRoute("/_layout-nosidebar/manageAgentJobs")({
    component: ManageAgentJobsPage,
});

export default function ManageAgentJobsPage() {
    return <ManageAgentJobsRoute />;
}
